import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { exportParameters } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useFetchExportParameters = () => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useQuery(
    ['ExportParameters', orgId],
    async () => axiosInstance.get(exportParameters(orgId).list),
    {
      refetchOnWindowFocus: false,
      select: (res) => {
        const partnerAccounts = res.data?.partnerAccounts || [];
        return partnerAccounts.map(account => ({
          id: account.ID,
          name: account.name,
          partnerId: account.partner?.ID ?? '',
          partnerName: account.partner?.name ?? '',
          parameters: account.parameters ?? [],
        }));
      },
      onError: (err) => {
        dispatch(showAlert({
          message: err?.response?.data?.message || 'Failed to fetch export parameters',
          type: 'error',
        }));
      },
    },
  );
};
